import { Component, EventEmitter, HostBinding, Input, Output, } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
function ToggletipComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.toggletipMessage, " ");
} }
function ToggletipComponent_ng_template_4_Template(rf, ctx) { }
const _c0 = function (a0) { return { toggletipMessage: a0 }; };
export class ToggletipComponent {
    constructor(el) {
        this.el = el;
        this.placement = 'top';
        this.toggleOnClick = true;
        this.afterViewInit = new EventEmitter();
    }
    get toggletipId() {
        return this.id;
    }
    ngAfterViewInit() {
        this.afterViewInit.emit();
    }
    get classes() {
        return `popover dpg-ui-toggletip ${this.placement}`;
    }
}
ToggletipComponent.ɵfac = function ToggletipComponent_Factory(t) { return new (t || ToggletipComponent)(i0.ɵɵdirectiveInject(i0.ElementRef)); };
ToggletipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ToggletipComponent, selectors: [["mhe-toggletip"]], hostVars: 1, hostBindings: function ToggletipComponent_HostBindings(rf, ctx) { if (rf & 2) {
        i0.ɵɵattribute("id", ctx.toggletipId);
    } }, inputs: { id: "id", placement: "placement", toggletipMessage: "toggletipMessage", templateRef: "templateRef", toggleOnClick: "toggleOnClick" }, outputs: { afterViewInit: "afterViewInit" }, decls: 6, vars: 5, consts: [["role", "tooltip", 1, "toggletip-content"], ["default", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "arrow"], ["cdkFocusInitial", "", 1, "popover-body"]], template: function ToggletipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div")(1, "div", 0);
        i0.ɵɵtemplate(2, ToggletipComponent_ng_template_2_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
        i0.ɵɵtemplate(4, ToggletipComponent_ng_template_4_Template, 0, 0, "ng-template", 2);
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "div", 3);
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(3);
        i0.ɵɵattribute("class", ctx.classes);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngTemplateOutlet", ctx.templateRef || _r0)("ngTemplateOutletContext", i0.ɵɵpureFunction1(3, _c0, ctx.toggletipMessage));
    } }, dependencies: [i1.NgTemplateOutlet], styles: ["[_nghost-%COMP%]{position:inherit}.popover[_ngcontent-%COMP%]{display:block;background-color:#fff;position:relative}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ToggletipComponent, [{
        type: Component,
        args: [{ selector: 'mhe-toggletip', template: "<div [attr.class]=\"classes\">\n  <div class=\"toggletip-content\" role=\"tooltip\">\n    <ng-template #default let-options=\"options\">\n      <div class=\"popover-body\" cdkFocusInitial>\n        {{ toggletipMessage }}\n      </div>\n    </ng-template>\n\n    <ng-template\n      [ngTemplateOutlet]=\"templateRef || default\"\n      [ngTemplateOutletContext]=\"{ toggletipMessage: toggletipMessage }\"\n    ></ng-template>\n  </div>\n\n  <!-- anchor arrow -->\n  <div class=\"arrow\"></div>\n</div>\n", styles: [":host{position:inherit}.popover{display:block;background-color:#fff;position:relative}/*# sourceMappingURL=toggletip.component.css.map */\n"] }]
    }], function () { return [{ type: i0.ElementRef }]; }, { toggletipId: [{
            type: HostBinding,
            args: ['attr.id']
        }], id: [{
            type: Input
        }], placement: [{
            type: Input
        }], toggletipMessage: [{
            type: Input
        }], templateRef: [{
            type: Input
        }], toggleOnClick: [{
            type: Input
        }], afterViewInit: [{
            type: Output
        }] }); })();
